import { action, computed, thunkOn } from "easy-peasy";
import { onLogoutResolver } from "./on-logout-resolver";

const modelDeadFlopptions = {
  INITIAL_DATA_ENDPOINT: "dead_flopptions",
  NAME: "dead_flopptions",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: true,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: true,
  initialData: [],
  initialDataReceived: false,
  initialDataLoading: false,
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = [];
    state.initialDataReceived = false;
    state.initialDataLoading = false;
  }),
  onLogout: thunkOn(onLogoutResolver, (actions) => {
    actions.resetData();
  }),
  // receivedFor: computed(
  //   state =>
  //     new Set(
  //       state.initialData.map(({ TripId, leg_i }) => `${TripId}.${leg_i}`)
  //     )
  // ),
  receiveInitialData: action((state, payload) => {
    state.initialData = payload.map((flop) => ({
      ...flop,
      id: flop.flopption_id,
    }));
  }),
  rowsByTripLegId: computed((state) => ({ TripId, leg_i }) => {
    if (TripId === null || leg_i === null) return [];
    const key = `${TripId}-${leg_i}`;
    return state.initialData.filter((row) => row["TripId-leg_i"] === key);
  }),
  // maybeFetchOne: thunk(
  //   async (actions, { TripId, leg_i }, { getState, getStoreState }) => {
  //     const receivedFor = getState().receivedFor;
  //     console.log({
  //       receivedFor,
  //       has: receivedFor.has(`${TripId}-${leg_i}`),
  //       id: `${TripId}.${leg_i}`
  //     });
  //     if (receivedFor.has(`${TripId}.${leg_i}`)) return null;
  //     const resp = await makeAuthorizedGetRequestToBackend({
  //       url: makeUrl(
  //         `dead_flopptions/${TripId}/${leg_i}`,
  //         getStoreState().misc.appMode
  //       )
  //     });
  //     actions.receiveInitialData(resp.data);
  //   }
  // ),
  // onVfOpenModal: thunkOn(
  //   (actions, storeActions) => storeActions.misc.vf_openModal,
  //   async (actions, target) => {
  //     if (target.payload.snapshot?.trip_dead !== undefined) {
  //       await actions.maybeFetchOne(target.payload.snapshot);
  //     }
  //   }
  // ),
  maybeHandleFetchInitialData: undefined,
  handleFetchInitialData: undefined,
  markInitialDataReceived: undefined,
};

export default modelDeadFlopptions;
